import React from 'react';
import styles from './CryptoTitle.module.css';
import Icon from '@/shared/components/Icon/Icon';

type Props = {
  assetId: string | undefined;
  children: React.ReactNode;
  className?: string;
};

const CryptoTitle: React.FC<Props> = ({ assetId, children, className }) => {
  return (
    <h2 className={`${styles.wrapper} ${className || ''}`}>
      <Icon
        size="large"
        color={assetId}
        src={`assets/icons/${assetId === 'eur' ? 'euro' : assetId}.svg`}
        className={styles.icon}
      />
      <div className={styles.title}>
        {children} <span className={styles.assetName}>{assetId?.toUpperCase()}</span>
      </div>
    </h2>
  );
};

export default CryptoTitle;
